"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WasNowPrice = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames4 = _interopRequireDefault(require("classnames"));
var _priceModule = _interopRequireDefault(require("./price.module.scss"));
var _generateAriaLabel = require("./helpers/generateAriaLabel");
var _getPriceOrRange = require("./helpers/getPriceOrRange");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var WasNowPrice = exports.WasNowPrice = function WasNowPrice(_ref) {
  var className = _ref.className,
    dataTestPrefix = _ref.dataTestPrefix,
    _ref$price = _ref.price,
    was = _ref$price.was,
    then1 = _ref$price.then1,
    then2 = _ref$price.then2,
    now = _ref$price.now,
    pricePrefix = _ref.pricePrefix,
    priceSuffix = _ref.priceSuffix,
    usageContext = _ref.usageContext,
    showPriceReduction = _ref.showPriceReduction,
    unitPriceWording = _ref.unitPriceWording,
    isAnyday = _ref.isAnyday,
    isProductCard = _ref.isProductCard,
    isQuickView = _ref.isQuickView,
    reducedPrice = _ref.reducedPrice;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
    className: (0, _classnames4["default"])(className, _priceModule["default"]['price'], _priceModule["default"]['price--reduced'], _priceModule["default"]["price--context-".concat(usageContext)], _defineProperty({}, _priceModule["default"]['price--anyday'], isAnyday)),
    "data-test": dataTestPrefix ? "".concat(dataTestPrefix, "-price") : 'price',
    "aria-label": (0, _generateAriaLabel.generateAriaLabel)(was, then1, then2, now, pricePrefix, priceSuffix),
    children: [[was, then1, then2].map(function (previousPrice, index) {
      return previousPrice && [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: (0, _classnames4["default"])(_priceModule["default"]['price__prev'], _defineProperty({}, _priceModule["default"]['price__right-padding'], isQuickView)),
        "data-test": dataTestPrefix ? "".concat(dataTestPrefix, "-price-prev") : 'price-prev',
        role: "presentation",
        children: (0, _getPriceOrRange.getPriceOrRange)(previousPrice)
      }, "".concat(index < 1 ? 'was' : 'then', "Value").concat(previousPrice.from || previousPrice))];
    }), now && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: (0, _classnames4["default"])(_priceModule["default"]['price__now'], _defineProperty({}, _priceModule["default"]['price__right-padding'], isQuickView)),
      "data-test": dataTestPrefix ? "".concat(dataTestPrefix, "-price-now") : 'price-now',
      role: "presentation",
      children: [pricePrefix && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _classnames4["default"])(_priceModule["default"]['price__prefix']),
          children: pricePrefix
        }), ' ']
      }), (0, _getPriceOrRange.getPriceOrRange)(now), priceSuffix && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _classnames4["default"])(_priceModule["default"]['price__suffix']),
          children: priceSuffix
        })]
      })]
    }), unitPriceWording && !isProductCard ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: (0, _classnames4["default"])(_priceModule["default"]['price__unit-price'], _priceModule["default"]["price__unit-price-".concat(usageContext)]),
      "aria-label": unitPriceWording,
      children: unitPriceWording
    }) : null, showPriceReduction && reducedPrice && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: (0, _classnames4["default"])(_priceModule["default"]['price__reduction']),
      "data-test": dataTestPrefix ? "".concat(dataTestPrefix, "-price-reduction") : 'price-reduction',
      "aria-label": "Save ".concat(reducedPrice),
      children: ["Save ", reducedPrice]
    })]
  });
};